import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";
import Joi from "joi-browser";

import FormGrid from "../../../components/forms/FormGrid";
import contactFields from "./contactFields";
import { FormikForm, ActionButtons } from "../../../components/forms";
import propTypes from "../../../constants/propTypes";
import { isSuperAdmin } from "../../../utils/roleUtils";
import DuplicatePersonDialog from "../../DuplicatePersonDialog";
import {
  addressBookDataComponentId,
  contactDataComponentId,
} from "./AddressBook";

export const getContactSchema = (userRole, isUpdate) => {
  const schema = BWModels.loadSchema("Contact").concat(
    Joi.object().keys({
      person: BWModels.loadSchema("Person"),
    })
  );
  if (isSuperAdmin(userRole) && !isUpdate) {
    return schema.keys({
      scopeId: BWModels.Joi.selectFk().required(),
    });
  }
  return schema;
};

export default class ContactForm extends Component {
  static propTypes = {
    contact: PropTypes.object,
    onSubmit: PropTypes.func,
    isEditing: PropTypes.bool,
    userRole: propTypes.userRole,
    addressBookId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
  };

  render() {
    const { onSubmit, userRole, isEditing, addressBookId } = this.props;

    return (
      <FormikForm
        initialValues={{ ...this.props.contact }}
        onSubmit={onSubmit}
        validationSchema={getContactSchema(userRole, isEditing)}
        ignoreValidationFieldNames={["name", "status"]}
        {...this.formPatchProps}
      >
        {({ handleSubmit, values, errors, ...formikProps }) => {
          return (
            <Fragment>
              <FormGrid
                fields={contactFields(userRole, isEditing)}
                values={values}
                {...formikProps}
              />
              <DuplicatePersonDialog
                dataComponentId={addressBookDataComponentId}
                contactRelationId={addressBookId}
                affectedPersonPath="personId"
                personPath="person"
              />
              <DuplicatePersonDialog
                dataComponentId={contactDataComponentId}
                contactRelationId={addressBookId}
                affectedPersonPath="personId"
                personPath="person"
              />
              <ActionButtons isModal={true} onSend={handleSubmit} />
            </Fragment>
          );
        }}
      </FormikForm>
    );
  }
}
